import { render, staticRenderFns } from "./boardUserPopup.vue?vue&type=template&id=2a7d107a&scoped=true&"
import script from "./boardUserPopup.vue?vue&type=script&lang=js&"
export * from "./boardUserPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d107a",
  null
  
)

export default component.exports